<div class="fleet-container">
  <!-- Page Header -->
  <app-title-bar
    title="Fleet Management"
    description="Manage all your fleet clients and vehicles in one place."
    [showButton]="true"
    buttonText="Add Fleet"
    buttonVariant="primary"
    (buttonClick)="onAddFleet()"
  >
  </app-title-bar>

  <!-- Stats Cards -->
  <div class="stats-container">
    <app-stats-card
      *ngFor="let stat of fleetStatsWithIcons(); trackBy: trackByIndex"
      [title]="stat.title"
      [value]="stat.value"
      [color]="stat.color"
      [icon]="stat.icon"
      [iconClass]="stat.iconClass"
      [iconStyle]="stat.iconStyle"
    >
    </app-stats-card>
  </div>

  <!-- Search and Filter Section -->
  <div class="search-filter-section">
    <app-searchbar
      placeholder="Search for clients by name."
      [(searchTerm)]="searchTerm"
      (searchChange)="onSearchChange($event)"
      iconSize="small"
    >
    </app-searchbar>
    <div class="filter-container">
      <app-action-button
        buttonText="Filter"
        iconSrc="assets/images/package/adjustments.svg"
        [showCount]="hasActiveFilters()"
        [count]="getActiveFilterCount()"
        (buttonClick)="onShowFilterModal()"
      >
      </app-action-button>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="error()" class="error-message">
    {{ error() }}
  </div>

  <!-- Fleet Table (Only show when there are fleets to display) -->
  <div *ngIf="!loading() && filteredClients().length > 0" class="fleet-table-container">
    <div class="table-container">
      <div class="table-scroll-wrapper">
        <table class="fleet-table">
          <thead>
            <tr>
              <th>Business Name</th>
              <th>Status</th>
              <th>Package</th>
              <th>Charged Price</th>
              <th>Location</th>
              <th>Billing Cycle</th>
              <th>Duration</th>
              <th>Vehicles</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let client of filteredClients(); trackBy: trackByClientId">
              <td>{{ client.clientName || '-' }}</td>
              <td>
                <span class="status-badge" [ngClass]="'status-' + (client.status || 'active')">
                  {{ formatContractStatus(client.status) }}
                </span>
              </td>
              <td>{{ client.package || '-' }}</td>
              <td>{{ formatChargedPrice(client) }}</td>
              <td>{{ client.branch || '-' }}</td>
              <td>{{ client.billingCycleDisplay || '-' }}</td>
              <td>{{ formatDuration(client) }}</td>
              <td>
                <button class="license-plate-btn" (click)="onManageLicensePlates(client.id)">
                  {{
                    client.licensePlateCount > 0
                      ? client.licensePlateCount +
                        (client.licensePlateCount === 1 ? ' vehicle' : ' vehicles')
                      : client.vehicles || '-'
                  }}
                </button>
              </td>
              <td>
                <div class="action-buttons">
                  <button
                    class="action-btn action-btn--history"
                    (click)="onViewServiceHistory(client)"
                  >
                    <svg
                      class="history-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5" />
                      <path
                        d="M8 4.67V8l2 1.33"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    History
                  </button>
                  <button class="action-btn action-btn--invoice" (click)="onInvoiceClick(client)">
                    <svg
                      class="invoice-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M2 1.33h8.67l3.33 3.33v10.67H2V1.33z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path d="M10.67 1.33v3.33h3.33" stroke="currentColor" stroke-width="1.5" />
                      <path
                        d="M4.93 4.67h4.67M4.93 7.33h4.67"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Invoice
                  </button>
                  <div class="actions-cell" (click)="$event.stopPropagation()">
                    <button
                      class="actions-button"
                      (click)="toggleFleetActionsDropdown($event, client.id)"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 8.66667C8.36819 8.66667 8.66667 8.36819 8.66667 8C8.66667 7.63181 8.36819 7.33333 8 7.33333C7.63181 7.33333 7.33333 7.63181 7.33333 8C7.33333 8.36819 7.63181 8.66667 8 8.66667Z"
                          stroke="currentColor"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4C8.36819 4 8.66667 3.70152 8.66667 3.33333C8.66667 2.96514 8.36819 2.66667 8 2.66667C7.63181 2.66667 7.33333 2.96514 7.33333 3.33333C7.33333 3.70152 7.63181 4 8 4Z"
                          stroke="currentColor"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 13.3333C8.36819 13.3333 8.66667 13.0349 8.66667 12.6667C8.66667 12.2985 8.36819 12 8 12C7.63181 12 7.33333 12.2985 7.33333 12.6667C7.33333 13.0349 7.63181 13.3333 8 13.3333Z"
                          stroke="currentColor"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Loading State - Shimmer Effect -->
  <div *ngIf="loading()" class="loading-container">
    <app-loading-table-shimmer
      [columns]="shimmerColumns"
      [rows]="5"
      [showHeader]="false"
      className="scrollable"
    >
    </app-loading-table-shimmer>
  </div>

  <!-- Empty State - No Fleets -->
  <div
    *ngIf="!loading() && fleetClients().length === 0 && !searchTerm() && !hasActiveFilters()"
    class="empty-state-container"
  >
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img src="/assets/images/empty_screen.png" alt="No fleets" class="empty-illustration" />
      </div>
      <div class="empty-state-text">
        <h2 class="empty-state-title">No fleets to show!</h2>
        <p class="empty-state-description">Create fleets to track and manage them here.</p>
      </div>
      <div class="empty-state-action">
        <button class="add-fleet-btn" (click)="onAddFleet()">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 4V16M4 10H16"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Add Fleet
        </button>
      </div>
    </div>
  </div>

  <!-- Empty State - No Search Results -->
  <div
    *ngIf="!loading() && fleetClients().length === 0 && (searchTerm() || hasActiveFilters())"
    class="empty-state-container"
  >
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img
          src="/assets/images/empty_screen.png"
          alt="No results found"
          class="empty-illustration"
        />
      </div>
      <div class="empty-state-text">
        <h2 class="empty-state-title">No results found!</h2>
        <p class="empty-state-description">Please try again or modify your search or filters.</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <app-pagination-bar
    *ngIf="filteredClients().length > 0"
    [paginationData]="paginationData"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  ></app-pagination-bar>

  <!-- Filter Modal -->
  <app-filter-modal
    [isVisible]="showFilterModal()"
    header="Filters"
    primaryButtonText="Apply Filters"
    secondaryButtonText="Clear Filters"
    [categories]="filterCategories()"
    (close)="onCloseFilterModal()"
    (apply)="onFilterModalApply($event)"
  >
  </app-filter-modal>

  <!-- Add Fleet Modal -->
  <app-add-fleet-modal
    *ngIf="showAddFleetModal()"
    (close)="onCloseAddFleetModal()"
    (save)="onSaveFleet($event)"
  ></app-add-fleet-modal>

  <!-- Edit Fleet Modal -->
  <app-add-fleet-modal
    *ngIf="showEditFleetModal()"
    [isEditMode]="true"
    [editFleetData]="editFleetData()"
    (close)="onCloseEditFleetModal()"
    (save)="onSaveEditFleet($event)"
  ></app-add-fleet-modal>

  <!-- Active/Inactive change confirmation -->
  <app-confirm-action-modal
    *ngIf="pendingStatusChange()"
    [title]="pendingStatusChange()?.status === 'active' ? 'Activate fleet?' : 'Deactivate fleet?'"
    [message]="statusChangeMessage()"
    [confirmLabel]="pendingStatusChange()?.status === 'active' ? 'Activate' : 'Deactivate'"
    cancelLabel="Cancel"
    (confirm)="onConfirmStatusChange()"
    (cancel)="onCancelStatusChange()"
  ></app-confirm-action-modal>

  <!-- Success Modal -->
  <app-success-modal
    [isVisible]="showSuccessModal()"
    [data]="successModalData()"
    (close)="onSuccessModalClose()"
  ></app-success-modal>

  <!-- Invoice Modal -->
  <app-invoice-modal
    [isVisible]="showInvoiceModal()"
    [data]="invoiceModalData()"
    (close)="onInvoiceClose()"
    (generate)="onInvoiceGenerate()"
  ></app-invoice-modal>

  <!-- Service History Modal -->
  <app-service-history-modal
    [data]="serviceHistoryModalData()"
    (closeModal)="onServiceHistoryClose()"
  ></app-service-history-modal>

  <!-- License Plates Modal -->
  <app-license-plates-modal
    *ngIf="showLicensePlatesModal()"
    [fleetId]="selectedFleetId()"
    [fleetName]="selectedFleetName()"
    [locationName]="selectedFleetLocation()"
    [csvPreviewData]="csvPreviewData()"
    [modalMode]="licensePlatesModalMode()"
    (close)="onCloseCsvPreview()"
    (importLicensePlates)="onImportLicensePlatesFromModal()"
    (editLicensePlate)="onEditLicensePlate($event)"
    (deleteLicensePlate)="onDeleteLicensePlate($event)"
  ></app-license-plates-modal>

  <!-- Add License Plates Modal -->
  <app-add-license-plates-modal
    *ngIf="showAddLicensePlatesModal()"
    [fleetId]="selectedFleetId()"
    [fleetName]="selectedFleetName()"
    (close)="onCloseAddLicensePlatesModal()"
    (success)="onLicensePlatesImported($event)"
    (viewFile)="onViewFile($event)"
  ></app-add-license-plates-modal>

  <!-- Global Dropdown Menu for Fleet -->
  <div
    class="actions-dropdown-menu"
    *ngIf="activeFleetActionsDropdown() && selectedFleetForDropdown()"
    [id]="'fleet-dropdown-' + activeFleetActionsDropdown()"
  >
    <div class="dropdown-item" (click)="onEditFleet(selectedFleetForDropdown()!.id)">
      <div class="dropdown-content">
        <span class="dropdown-text">Edit</span>
        <img
          src="/assets/images/pencil.svg"
          alt="Edit"
          class="dropdown-icon"
          width="14"
          height="14"
        />
      </div>
    </div>
  </div>

  <!-- Toast Messages -->
</div>
